import styled from 'styled-components';
import { RichText } from '@oneaudi/unified-web-components';
import {
  SYS_SPACE_FIXED_200,
  SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL,
} from '@oneaudi/unified-web-alpha-common';

export const StyledRichText = styled(RichText)`
  margin-top: ${SYS_SPACE_FIXED_200};
  font-size: ${SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL.fontSize};
  line-height: ${SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL.lineHeight};
  letter-spacing: ${SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL.letterSpacing};

  :first-child {
    margin-top: 0;
  }

  svg {
    display: none;
  }

  a {
    font-size: inherit;
    line-height: inherit;
    letter-spacing: 0;
  }
`;
